var $1b424c160db5642d$exports = {};
$1b424c160db5642d$exports = {
    "alert": `Ostrze\u{17C}enie`,
    "dismiss": `Zignoruj`
};


export {$1b424c160db5642d$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
